import { render, staticRenderFns } from "./DeviceRealtimeStatus.vue?vue&type=template&id=2785a4ff&scoped=true&"
import script from "./DeviceRealtimeStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceRealtimeStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRealtimeStatus.vue?vue&type=style&index=0&id=2785a4ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785a4ff",
  null
  
)

export default component.exports